import {
    memo, FC, useState,
    useEffect, Dispatch, SetStateAction,
    useRef
} from 'react';
import { Element } from 'react-scroll';

import classes from './styles.module.css';
import { HiOutlineSearch } from "react-icons/hi";
import { useTranslation } from 'react-i18next';


interface SearchProp {
    setSearch: Dispatch<SetStateAction<string>>;
    focus?: boolean;
    initialValue?: string;
}

const Search: FC<SearchProp> = ({ setSearch, focus, initialValue = '' }) => {
    const [searchTerm, setSearchTerm] = useState<string>(initialValue);
    const inputRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation(["products"]);


    useEffect(() => {
        const handler = setTimeout(() => {
            setSearch(searchTerm);
        }, 500); // 500ms debounce time

        // Cleanup timeout if the component unmounts or the searchTerm changes
        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm, setSearch]);

    const searchOnChangeHandle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    useEffect(() => {
        if (focus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [focus]);


    return (
        <Element name="searchBar">
            <div className={classes.search}>
                <div className={classes.search__wrap}>
                    <input
                        type="text"
                        className={`form-control search-input ${classes.search__input}`}
                        placeholder={t("search.placeholder")}
                        aria-label={t("search.placeholder")}
                        aria-describedby="button-addon2"
                        value={searchTerm}
                        onChange={searchOnChangeHandle}
                        ref={inputRef}
                    />
                    <button className={classes.search__btn} type="button" id="button-addon2" aria-label={t("search.submit")}>
                        <HiOutlineSearch size={18} />
                    </button>
                </div>
            </div>
        </Element>
    );
}

export default memo(Search);
